import { c as _c } from "react/compiler-runtime";
import React, { useState, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import PDPProtectionPlanSelector from 'components/consumer/PDP/PDPProtectionPlanSelector';
import useProductEFGInternalStatus from 'data-hooks/useProductEFGInternalStatus';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import BrowserOnly from 'components/consumer/BrowserOnly';
import ReRenderOnMount from 'components/consumer/ReRenderOnMount';
import useIsBrowser from 'hooks/useIsBrowser';
import PDPNameSection from '../PDPNameSection';
import PDPMobileStudioPhotoGallery from '../PDPMobileStudioPhotoGallery';
import PDPShopTabsBar from '../PDPShopTabsBar';
import PDPAvailableInSizes from '../PDPAvailableInSizes';
import PDPOnDisplayInShowroom from '../PDPOnDisplayInShowroom';
import PDPMobileConfigurationPhotoGallery from '../PDPMobileConfigurationPhotoGallery';
import PDPChooseYourOptions from '../PDPChooseYourOptions';
import PDPUpSellProduct from '../PDPUpSellProduct';
import PDPCompleteOrder from '../PDPCompleteOrder';
import PDPAddToBagSection from '../PDPAddToBagSection';
import PDPKeySellingPoints from '../PDPKeySellingPoints';
import PDPSellingAttributes from '../PDPSellingAttributes';
import PDPProductDescription from '../PDPProductDescription';
import PDPDimensionsAndDetails from '../PDPDimensionsAndDetails';
import BVReviewsOnShowHost from '../BazaarVoice/BVReviewsOnShowHost';
import PDPCustomerPhotos from '../PDPCustomerPhotos';
import PDPBreadCrumbs from '../PDPBreadCrumbs';
import PDPAlertBar from '../PDPAlertBar';
import PDPDetailsAndProductCareLink from '../PDPDetailsAndProductCareLink';
import PDPAlertsSection from '../PDPAlertsSection';
import PDPDiscontinuedMessage from '../PDPDiscontinuedMessage';
import usePDPOptions from '../state/context/usePDPOptions';
import PDPMobilePlaceholder from '../PDPMobilePlaceholder';
const PDPCollectionSlider = loadable(() => import('../PDPCollectionSlider'));
const ModularAddProductsMarxent = loadable(() => import('components/consumer/modular-configurator/ModularAddProducts/marxent'));
const PDPMobileInner = t0 => {
  const $ = _c(71);
  const {
    slug,
    isOutOfStock: t1,
    showOutOfStockNotification: t2,
    pdpIsModularBYOProduct: t3,
    isEditOrder: t4,
    showDiscontinuedNotification: t5,
    discontinuedCategoryMsg: t6
  } = t0;
  const isOutOfStock = t1 === undefined ? false : t1;
  let t7;
  if ($[0] !== t2) {
    t7 = t2 === undefined ? {} : t2;
    $[0] = t2;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const showOutOfStockNotification = t7;
  const pdpIsModularBYOProduct = t3 === undefined ? false : t3;
  const isEditOrder = t4 === undefined ? false : t4;
  const showDiscontinuedNotification = t5 === undefined ? false : t5;
  const discontinuedCategoryMsg = t6 === undefined ? null : t6;
  const {
    isEFGInternal: t8
  } = useProductEFGInternalStatus();
  const isEFGInternal = t8 === undefined ? false : t8;
  const {
    data: optionData
  } = usePDPOptions();
  const isBrowser = useIsBrowser();
  const [displayPressComp, setDisplayPressComp] = useState(false);
  const [marxentSelectedFabric, setMarxentSelectedFabric] = useState(null);
  const [hideMarxent, setHideMarxent] = useState(true);
  const [unavailableFabric, setUnavailableFabric] = useState(false);
  const galleryRef = useRef(null);
  let t9;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      if (galleryRef.current) {
        galleryRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    };
    $[2] = t9;
  } else {
    t9 = $[2];
  }
  const scrollToGallery = t9;
  let t10;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="mb-4"><PDPBreadCrumbs /></div>;
    $[3] = t10;
  } else {
    t10 = $[3];
  }
  let t11;
  if ($[4] !== isEditOrder) {
    t11 = <PDPNameSection isEditOrder={isEditOrder} />;
    $[4] = isEditOrder;
    $[5] = t11;
  } else {
    t11 = $[5];
  }
  let t12;
  if ($[6] !== isBrowser || $[7] !== isEditOrder) {
    t12 = !isEditOrder && isBrowser ? <PDPAvailableInSizes /> : <div className="PDP__PDPAvailableInSizes-filler" />;
    $[6] = isBrowser;
    $[7] = isEditOrder;
    $[8] = t12;
  } else {
    t12 = $[8];
  }
  let t13;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <PDPOnDisplayInShowroom />;
    $[9] = t13;
  } else {
    t13 = $[9];
  }
  let t14;
  if ($[10] !== t12) {
    t14 = <FixedWidthContainer>{t12}{t13}</FixedWidthContainer>;
    $[10] = t12;
    $[11] = t14;
  } else {
    t14 = $[11];
  }
  let t15;
  if ($[12] !== pdpIsModularBYOProduct) {
    t15 = <div><PDPMobileStudioPhotoGallery pdpIsModularBYOProduct={pdpIsModularBYOProduct} /></div>;
    $[12] = pdpIsModularBYOProduct;
    $[13] = t15;
  } else {
    t15 = $[13];
  }
  let t16;
  if ($[14] !== isEditOrder) {
    t16 = <FixedWidthContainer><PDPShopTabsBar isEditOrder={isEditOrder} /></FixedWidthContainer>;
    $[14] = isEditOrder;
    $[15] = t16;
  } else {
    t16 = $[15];
  }
  let t17;
  if ($[16] !== hideMarxent || $[17] !== isEFGInternal || $[18] !== isEditOrder || $[19] !== optionData?.hasSingleOptionValue || $[20] !== pdpIsModularBYOProduct || $[21] !== slug || $[22] !== unavailableFabric) {
    t17 = <ReRenderOnMount>{!isEFGInternal || isEFGInternal && !optionData?.hasSingleOptionValue ? <div className="PDPMobile__PDPMobileConfigurationPhotoGallery-wrapper" ref={galleryRef}><PDPMobileConfigurationPhotoGallery slug={slug} isEditOrder={isEditOrder} pdpIsModularBYOProduct={pdpIsModularBYOProduct} marxentPostHogFlag="test" hideMarxent={hideMarxent} unavailableFabric={unavailableFabric} /></div> : <div className="PDPMobile__PDPMobileConfigurationPhotoGallery-wrapper-filler" />}</ReRenderOnMount>;
    $[16] = hideMarxent;
    $[17] = isEFGInternal;
    $[18] = isEditOrder;
    $[19] = optionData?.hasSingleOptionValue;
    $[20] = pdpIsModularBYOProduct;
    $[21] = slug;
    $[22] = unavailableFabric;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== discontinuedCategoryMsg || $[25] !== showDiscontinuedNotification) {
    t18 = showDiscontinuedNotification ? <PDPAlertBar type="error"><PDPDiscontinuedMessage discontinuedCategoryMsg={discontinuedCategoryMsg} /></PDPAlertBar> : <div className="PDPMobile__PDPAlertBar-filler" />;
    $[24] = discontinuedCategoryMsg;
    $[25] = showDiscontinuedNotification;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] !== isEditOrder || $[28] !== isOutOfStock || $[29] !== marxentSelectedFabric || $[30] !== pdpIsModularBYOProduct || $[31] !== showDiscontinuedNotification || $[32] !== slug || $[33] !== unavailableFabric) {
    t19 = !isOutOfStock && !showDiscontinuedNotification ? <div className="PDPMobile__PDPChooseYourOptions-wrapper">{pdpIsModularBYOProduct && <BrowserOnly><div className="border-t border-gray-light7"><SuspenseWithLoader><ModularAddProductsMarxent marxentSelectedFabric={marxentSelectedFabric} unavailableFabric={unavailableFabric} setHideMarxent={setHideMarxent} setUnavailableFabric={setUnavailableFabric} scrollToGallery={scrollToGallery} key={slug} /></SuspenseWithLoader></div></BrowserOnly>}<PDPChooseYourOptions isEditOrder={isEditOrder} setMarxentSelectedFabric={setMarxentSelectedFabric} />{!isEditOrder && <PDPUpSellProduct />}{!isEditOrder && <PDPProtectionPlanSelector />}</div> : <div className="PDPMobile__PDPChooseYourOptions-wrapper-filler" />;
    $[27] = isEditOrder;
    $[28] = isOutOfStock;
    $[29] = marxentSelectedFabric;
    $[30] = pdpIsModularBYOProduct;
    $[31] = showDiscontinuedNotification;
    $[32] = slug;
    $[33] = unavailableFabric;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== isOutOfStock || $[36] !== showDiscontinuedNotification || $[37] !== showOutOfStockNotification) {
    t20 = isOutOfStock && !showDiscontinuedNotification ? <PDPAlertsSection showOutOfStockNotification={showOutOfStockNotification} /> : <div className="PDPMobile__PDPAlertSection-filler" />;
    $[35] = isOutOfStock;
    $[36] = showDiscontinuedNotification;
    $[37] = showOutOfStockNotification;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== isEditOrder || $[40] !== isOutOfStock) {
    t21 = isEditOrder ? <PDPCompleteOrder /> : <PDPAddToBagSection isOutOfStock={isOutOfStock} />;
    $[39] = isEditOrder;
    $[40] = isOutOfStock;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== t18 || $[43] !== t19 || $[44] !== t20 || $[45] !== t21) {
    t22 = <div>{t18}{t19}{t20}{t21}</div>;
    $[42] = t18;
    $[43] = t19;
    $[44] = t20;
    $[45] = t21;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  let t24;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <PDPKeySellingPoints />;
    t24 = <PDPSellingAttributes />;
    $[47] = t23;
    $[48] = t24;
  } else {
    t23 = $[47];
    t24 = $[48];
  }
  let t25;
  if ($[49] !== isEditOrder) {
    t25 = !isEditOrder && <PDPProductDescription />;
    $[49] = isEditOrder;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] !== pdpIsModularBYOProduct) {
    t26 = !pdpIsModularBYOProduct ? <PDPDimensionsAndDetails /> : <PDPDetailsAndProductCareLink />;
    $[51] = pdpIsModularBYOProduct;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[53] !== isEditOrder || $[54] !== slug) {
    t27 = !isEditOrder ? <PDPCustomerPhotos slug={slug} /> : <BVReviewsOnShowHost />;
    $[53] = isEditOrder;
    $[54] = slug;
    $[55] = t27;
  } else {
    t27 = $[55];
  }
  let t28;
  if ($[56] !== displayPressComp) {
    t28 = !displayPressComp ? <SuspenseWithLoader><PDPCollectionSlider setDisplayPressComp={setDisplayPressComp} /></SuspenseWithLoader> : <div className="PDPMobile__PDPPress-filler" />;
    $[56] = displayPressComp;
    $[57] = t28;
  } else {
    t28 = $[57];
  }
  let t29;
  if ($[58] !== t22 || $[59] !== t25 || $[60] !== t26 || $[61] !== t27 || $[62] !== t28) {
    t29 = <FixedWidthContainer>{t22}{t23}{t24}{t25}{t26}{t27}{t28}</FixedWidthContainer>;
    $[58] = t22;
    $[59] = t25;
    $[60] = t26;
    $[61] = t27;
    $[62] = t28;
    $[63] = t29;
  } else {
    t29 = $[63];
  }
  let t30;
  if ($[64] !== t11 || $[65] !== t14 || $[66] !== t15 || $[67] !== t16 || $[68] !== t17 || $[69] !== t29) {
    t30 = <div className="PDPMobile lg:hidden" data-xc="PDPMobile">{t10}{t11}{t14}{t15}{t16}{t17}{t29}</div>;
    $[64] = t11;
    $[65] = t14;
    $[66] = t15;
    $[67] = t16;
    $[68] = t17;
    $[69] = t29;
    $[70] = t30;
  } else {
    t30 = $[70];
  }
  return t30;
};
PDPMobileInner.propTypes = {
  discontinuedCategoryMsg: PropTypes.shape({
    category: PropTypes.string,
    link: PropTypes.string
  }),
  pdpIsModularBYOProduct: PropTypes.bool,
  isEditOrder: PropTypes.bool,
  isOutOfStock: PropTypes.bool,
  showDiscontinuedNotification: PropTypes.bool,
  showOutOfStockNotification: PropTypes.shape({
    productId: PropTypes.number,
    show: PropTypes.bool
  }),
  slug: PropTypes.string
};
const PDPMobile = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PDPMobilePlaceholder />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SuspenseWithLoader fallback={t0}><PDPMobileInner {...props} /></SuspenseWithLoader>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PDPMobile;